import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {ActivatedRoute, Router} from '@angular/router';
import {first} from 'rxjs';
import {InstitutionService} from '../../../services/institution.service';
import {BranchService} from '../../../services/branch.service';
import {PriceListService} from "../../../../product/services/price-list.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-branch-edit',
  templateUrl: './branch-edit.component.html',
  styleUrls: ['./branch-edit.component.scss']
})
export class BranchEditComponent implements OnInit{

  branchForm: FormGroup;
  priceLists: any[] = [];
  priceListSelected: number | undefined;
  institutions: any[] = [];
  institutionSelected: number | undefined;
  saving = false;
  isSubmitted = false;

  public data: any;
  id: number;

  loadForm = true;

  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private branchService: BranchService,
              private institutionService: InstitutionService,
              private priceListService: PriceListService,
              private translate: TranslateService,
              private toast: ToastrService,
              public activeModal: NgbActiveModal,
              public route: Router,
              public router: ActivatedRoute

  ) {
    this.branchForm = this.fb.group({
      institution: ['', Validators.required],
      code: ['', [Validators.required]],
      name: ['', [Validators.required]],
      email: ['', [Validators.email]],
      // phone: ['', [Validators.pattern(/^((?!672)\d{9}|672\d{6})$/)]],
      phone: [''],
      address: [''],
      nsifEmployerMatriculeNo: [''],
      priceLists: '',
      isEnable: '',

    });

  }

  ngOnInit(): void {
    this.branchForm.get('isEnable')?.setValue('1');
    // console.log(this.data.institution.name);
    this.id = this.router.snapshot.params.id;
    this.branchForm.patchValue(this.data);
    this.findInstitutions();
    this.findPriceLists();

    if (this.id){
      this.branchService.get(this.id)
          .pipe(first())
          .subscribe(x => {
            console.log(x);
            this.branchForm.patchValue(x);
            this.institutionSelected = x.institution ? x.institution['@id'] : null;
            this.priceListSelected = x.priceLists.map((c: any) => c['@id']);
            this.branchForm.get('isEnable')?.setValue(x.isEnable ? '1' : '0');
            this.loadForm = false;

          } );
    }

  }

  get fc(): any {
    return this.branchForm.controls;
  }

  onFormSubmit(): void{
    this.isSubmitted = true;
    // if (this.userForm.valid && this.fileHad && this.fileHad.name){
    if (this.branchForm.valid){
      this.saving = true;
      if (this.id){
        console.log('hello maoll');
        this.branchForm.get('isEnable')?.setValue(this.branchForm.get('isEnable')?.value === '1');
        this.branchService.put(this.id, this.branchForm.value).subscribe({
          next: (val: any) => {
            this.toast.success(this.translate.instant('branch') + ' ' + this.translate.instant('editeed') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.route.navigate(['/security/branch']);

          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            const errors: any[] = err;
            console.log(errors);

            if (err.violations){
              err.violations.forEach((v) => {
                if (v.propertyPath === 'code') {
                  this.branchForm.get('code')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'name') {
                  this.branchForm.get('name')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'phone') {
                  this.branchForm.get('phone')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'email') {
                  this.branchForm.get('email')?.setErrors({serverError: v.message});
                }

                this.saving = false;
              });
            }
            else {

              this.toast.error(err['hydra:description'], 'Error');
              this.saving = false;
            }

          }
        });
      }

    }
  }

  findInstitutions(): any{
    this.institutionService.getCollection().subscribe((data: any) => {
          console.log(data);
          this.institutions = data['hydra:member'];
          if (this.institutions){
            this.institutions = this.institutions.map((v) => {
              v.id = v['@id'];
              return v;
            });
          }

        },
        error => console.log(error)
    );
  }
  findPriceLists(): any{
    this.priceListService.getCollection().subscribe((data: any) => {
          console.log(data);
          this.priceLists = data['hydra:member'];
          this.priceLists = this.priceLists.map((v) => {
            v.id = v['@id'];
            return v;
          });
        },
        error => console.log(error)
    );
  }
}